import { Typography } from '@mui/material'

interface HighlightedValueProps {
  value: string | number
  color: string
  isBest: boolean
  onClick?: () => void
}

const HighlightedValue = ({ value, color, isBest, onClick }: HighlightedValueProps) => (
  <Typography
    sx={{
      color,
      fontWeight: Number(value) > 0 ? 'bold' : 'normal',
      border: isBest ? '1px solid #4caf50' : 'none',
      borderRadius: isBest ? '4px' : 0,
      padding: isBest ? '0px 2px' : 0,
      cursor: onClick ? 'pointer' : 'default',
      textDecoration: onClick ? 'underline' : 'none',
      '&:hover': onClick
        ? {
            opacity: 0.8,
          }
        : {},
    }}
    onClick={onClick}
  >
    {value}
  </Typography>
)

export default HighlightedValue
